import React from 'react';
import ClassNames from 'classnames';

import './default-loader.scss';

const DefaultLoader = ({
    color = '#FFFFFF', style = {}, className = '', ...rest
}) => {

    const newStyle = {
        backgroundColor: color,
        ...style,
    };

    return (
        <div className={ClassNames('DefaultLoader', className)} id="circularG" {...rest}>
            <div id="circularG_1" className="circularG" style={newStyle} />
            <div id="circularG_2" className="circularG" style={newStyle} />
            <div id="circularG_3" className="circularG" style={newStyle} />
            <div id="circularG_4" className="circularG" style={newStyle} />
            <div id="circularG_5" className="circularG" style={newStyle} />
            <div id="circularG_6" className="circularG" style={newStyle} />
            <div id="circularG_7" className="circularG" style={newStyle} />
            <div id="circularG_8" className="circularG" style={newStyle} />
        </div>
    );

};

export default DefaultLoader;
